import { HttpClient } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, interval } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { AnalyticsService } from './analytics.service';

// https://blog.bitsrc.io/how-to-implement-idle-timeout-in-angular-af61eefdb13b

const STORE_KEY = 'userLastActionTimestamp';

@Injectable()
export class IdleTrackerService extends AnalyticsService {
    static USER_IDLE_TIMER_VALUE_IN_MIN = 5;
    private sessionForIdle$ = interval(500).pipe(takeWhile(() => !this._userIdlenessChecker.getValue()));
    private userActivityChangeCallback: ($event: MouseEvent) => void;

    private _userIdlenessChecker = new BehaviorSubject<boolean>(false);
    userIdlenessChecker = this._userIdlenessChecker.asObservable();

    get lastActionTimestamp(): number {
        return parseInt(localStorage.getItem(STORE_KEY), 10);
    }

    set lastActionTimestamp(value) {
        localStorage.setItem(STORE_KEY, value.toString());

        if (this._userIdlenessChecker.getValue()) {
            this._userIdlenessChecker.next(false);

            this._initListener(IdleTrackerService.USER_IDLE_TIMER_VALUE_IN_MIN);
        }
    }

    constructor(http: HttpClient, zone: NgZone) {
        super(http);

        this._handleUserActiveState();

        zone.runOutsideAngular(() => {
            this.userActivityChangeCallback = ($event) => this._handleUserActiveState();
            window.document.addEventListener('mousemove', this.userActivityChangeCallback.bind(this), true);
        });

        this._initListener(IdleTrackerService.USER_IDLE_TIMER_VALUE_IN_MIN);
    }

    private _handleUserActiveState(): void {
        this.lastActionTimestamp = Date.now();
    }

    private _initListener(idleDurationInMin: number): void {
        this.sessionForIdle$.subscribe(() => {
            const now = Date.now();
            const timeleft = this.lastActionTimestamp + idleDurationInMin * 60 * 1000;
            const diff = timeleft - now;
            const isTimeout = diff < 0;

            if (isTimeout) {
                this._userIdlenessChecker.next(true);
            }
        });
    }
}
